import { render, staticRenderFns } from "./DashboardVideoModal.vue?vue&type=template&id=017ca060&scoped=true"
import script from "./DashboardVideoModal.vue?vue&type=script&lang=js"
export * from "./DashboardVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ca060",
  null
  
)

export default component.exports